import * as React from 'react';

// Import conversation image
import conversationImage from '@images_responsive/partnerships/conversation.jpg';

import {
  Container,
  ContentWrapper,
  ConversationImage,
  ConversationSection,
  Description,
  Heading,
  ImageContainer,
  LearnMoreButton,
  LeftSection,
  RightSection,
} from './conversation.styles';

export const ConversationComponent: React.FC = () => {
  return (
    <ConversationSection>
      <Container>
        <ContentWrapper>
          <LeftSection>
            <Heading>Start a conversation today</Heading>
            <Description>
              Let’s make life simpler for your community.
            </Description>
            <LearnMoreButton href="#contact">Learn more</LearnMoreButton>
          </LeftSection>
          <RightSection>
            <ImageContainer>
              <ConversationImage
                image={conversationImage}
                alt="Two people having a conversation in a modern kitchen"
                sizes="(min-width: 768px) 50vw, calc(100vw - 40px)"
              />
            </ImageContainer>
          </RightSection>
        </ContentWrapper>
      </Container>
    </ConversationSection>
  );
};
